"use client";
import { useD3ClientPage } from "@/hook/useD3ClientPage";
import { DebatesInfo } from "@/types";
import { formatRelativeTime } from "@/utils/formatUtil";
import { Box, Button, Stack, Typography, useTheme } from "@mui/material";
import VoteResultBar from "./VoteResultBar";
import GoogleTranslateText from "./GoogleTranslateText";
import { useLocale } from "next-intl";

interface VoteDetailProps {
  debate: DebatesInfo;
}

const VoteDetail = ({ debate }: VoteDetailProps) => {
  const theme = useTheme();
  const { t } = useD3ClientPage();
  const locale = useLocale();
  const isPros = debate.votes?.stance?.toUpperCase() === "pros";
  const color = isPros ? `green` : `red`;

  return (
    <Stack width="100%" spacing={2}>
      {/** 투표 버튼 영역 */}
      <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
        {/* 찬성 버튼  */}
        <Button
          component="div"
          variant="contained"
          size="large"
          sx={{
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText,
            width: "48%", // 찬성 버튼의 너비 (간격 확보)
            padding: "8px 12px",
          }}
        >
          <GoogleTranslateText sourceLang={debate.debate.lang} targetLang={locale} text={debate.debate.proName ?? ""} />
        </Button>

        {/* 반대 버튼  */}
        <Button
          component="div"
          variant="contained"
          size="large"
          sx={{
            backgroundColor: theme.palette.tertiary.main,
            color: theme.palette.secondary.contrastText,
            width: "48%", // 반대 버튼의 너비 (간격 확보)
            padding: "8px 12px",
          }}
        >
          <GoogleTranslateText sourceLang={debate.debate.lang} targetLang={locale} text={debate.debate.conName ?? ""} />
        </Button>
      </Box>

      {/** 투표 결과 바 */}
      <Box sx={{ width: "100%" }}>
        <VoteResultBar
          proCount={debate.statistics.agreeCount}
          conCount={debate.statistics.disagreeCount}
          height={15}
          width={"100%"}
        />
      </Box>
    </Stack>
  );
};

export default VoteDetail;
